import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import LanguageStrings from '../../../i18n/locales'

export interface siteDeleteState {
  isLoading: boolean
  error: string | undefined
  siteDeleteData: string | undefined
  httpStatus: number | undefined
}

export const initialState: siteDeleteState = {
  isLoading: true,
  error: undefined,
  siteDeleteData: undefined,
  httpStatus: 0
}

const DeviceManagementStrings = LanguageStrings().DeviceManagementCollectionStrings.TableComponent

const siteDeleteSlice = createSlice({
  name: 'siteDelete',
  initialState,
  reducers: {
    siteDeleteLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        siteDeleteData: undefined,
        httpStatus: 0
      }
    },
    siteDeleteUpdateAction: (state, action: PayloadAction<{ data: any, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        siteDeleteData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    siteDeleteErrorAction: (state, action: PayloadAction<{ errorMessage: string | undefined, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage ?? DeviceManagementStrings.NetworkError,
        siteDeleteData: undefined,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  siteDeleteLoadingAction,
  siteDeleteUpdateAction,
  siteDeleteErrorAction
} = siteDeleteSlice.actions

export default siteDeleteSlice.reducer
